import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import ReportCollection from "@/classes/ReportCollection";
import TimeInputBox from "@/components/TimeInputBoxes.vue";
import TimeGraphs from "@/components/TimeGraphs.vue";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import HolidayCollection from "@/classes/HolidayCollection";
let Home = class Home extends Vue {
    //to be used
    loadGlobalTariffs() {
        this.$store
            .dispatch("loadGlobalTariffsAsync")
            .then((result) => {
            this.$store.commit("setGlobalTariffs", result.data);
            this.$data.tariffs = this.$store.getters.getTariffs;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "Home.vue - loadHolidayData");
        });
    }
    // function that loads the holidays data object from the store. Loads locally if available API otherwise.
    loadHolidayData() {
        this.$data.holidays = this.$store.getters.getHolidays;
        if (this.$store.getters.getHolidays === null) {
            this.$data.loading = true;
            const currentYear = moment(this.$store.getters.getSelectedDate).format("YYYY");
            this.$store
                .dispatch("loadHolidaysAsync", { year: currentYear })
                .then((holidays) => {
                this.$store.commit("setHolidays", {
                    data: holidays.data,
                    year: currentYear,
                });
                this.$data.holidays = new HolidayCollection(holidays.data);
                this.$data.loading = false;
            })
                .catch((err) => {
                window.errorHandler.logError(err, "Home.vue - loadHolidayData");
                this.$data.loading = false;
            });
        }
        else {
            this.$data.loading = false; // stop loading if the data already exists
        }
    }
    calculateAvailableHours() {
        const start = window.dateHandler
            .getStartOfMonth(this.$store.getters.getSelectedDate)
            .format("YYYY-MM-DD");
        let totalHours = 0;
        for (let i = 0; i < moment(start).daysInMonth(); i++) {
            const date = window.dateHandler.addDays(start, i);
            if (this.isNonWorkingDay(date) === false) {
                totalHours += 8;
            }
        }
        return totalHours;
    }
    calculateWeekAvailable() {
        const start = window.dateHandler.getMondayFromDate(this.$store.getters.getSelectedDate);
        let totalHours = 0;
        for (let i = 0; i < 7; i++) {
            const date = window.dateHandler.addDays(start, i);
            if (this.isNonWorkingDay(date) === false) {
                totalHours += 8;
            }
        }
        return totalHours;
    }
    isNonWorkingDay(date) {
        const holidayColl = this.$data
            .holidays;
        let holiday;
        if (holidayColl !== undefined && holidayColl !== null) {
            holiday = holidayColl.getHolidayForDate(date);
        }
        if (holiday !== undefined) {
            return true;
        }
        else if (moment(date).isoWeekday() === 6 ||
            moment(date).isoWeekday() === 7) {
            return true;
        }
        else {
            return false;
        }
    }
    navigateToOverview() {
        this.$router.push({ path: "monthlySummary" });
    }
    selectDateFromCalendar() {
        this.$store.commit("setSelectedDate", {
            date: window.dateHandler.convertToUTCTime(this.$data.selectedDate),
        });
        this.$data.selectedDate = this.$store.getters.getSelectedDate;
        this.getDateInfo();
        this.loadHolidayData();
    }
    selectPreviousWeek() {
        const newDate = window.dateHandler.subtractWeeks(this.$store.getters.getSelectedDate, 1);
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-DD"),
        });
        this.getDateInfo();
        this.loadHolidayData();
    }
    selectNextWeek() {
        const newDate = window.dateHandler.addWeeks(this.$store.getters.getSelectedDate, 1);
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-DD"),
        });
        this.getDateInfo();
        this.loadHolidayData();
    }
    getDateInfo() {
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
    getReportsForDay(date) {
        if (this.$data.reports !== null) {
            return this.$data.reports[date];
        }
    }
};
Home = __decorate([
    Component({
        data() {
            return {
                reports: null,
                tariffs: null,
                selectedDate: this.$store.getters.getSelectedDate,
                dateInfo: this.$store.getters.getDateInfo,
                theme: {},
                monthTime: 0,
                weekTime: 0,
                holidays: null,
                loading: true,
                showDateCalendar: false,
            };
        },
        created() { },
        mounted() {
            this.$store.commit("setSelectedDate", { date: new Date() });
            this.getDateInfo();
            //console.log("params",this.$route.params);
            this.$data.tariffs = this.$store.getters.getTariffs;
            this.$data.theme = this.$store.getters.getTheme;
            this.$store.dispatch("loadSelectedMonthReports", this.$store.getters.getSelectedDate);
            window.eventBus.$on("selectedMonthReportsUpdated", () => {
                const tempReports = new ReportCollection();
                tempReports.importReportObjectsFromJson(this.$store.getters.getSelectedMonthReports); //create a report collection
                if (tempReports !== undefined) {
                    this.$data.reports = tempReports;
                    this.getDateInfo(); //calculates the total for the month and week
                }
            });
            this.loadHolidayData();
        },
        components: {
            TimeInputBox,
            IconBox,
            IconBoxContent,
            TimeGraphs,
            // Datepicker,
        },
    })
], Home);
export default Home;
